export default "__VITE_ASSET__0777027b__"